import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { DomainDesignation } from "@constants";
import { smoothEnter, smoothLeave, smoothAfterEnter } from "@utils/Routing";
import domainDisplay from "./Program.Performance.Domain.vue";
import domainIndicatorDisplay from "./Program.Performance.DomainIndicator.vue";
import domainComparison from "./Program.Performance.DomainComparison.vue";
export default {
  components: {
    domainDisplay,
    domainIndicatorDisplay,
    domainComparison
  },
  data() {
    return {
      DomainDesignation: DomainDesignation
    };
  },
  computed: {
    overall() {
      return this.$store.state.overallDomain;
    },
    overallWhy() {
      return this.$store.getters.overallDomainWhy;
    },
    domains() {
      return this.$store.state.domains;
    },
    routeDomain() {
      return this.$route.query.domain > 0 ? this.domains.find(x => x.DomainId == this.$route.query.domain) : null;
    },
    designations() {
      let data = [];
      for (let key in DomainDesignation) data.push(DomainDesignation[key]);
      return data;
    },
    entityProgram() {
      return this.$store.getters.programCategorySummary;
    },
    transitionName() {
      return this.routeDomain ? "slide-left" : "slide-right";
    }
  },
  methods: {
    leave: smoothLeave,
    enter: smoothEnter,
    afterEnter: smoothAfterEnter,
    enterCancelled: smoothAfterEnter,
    setDomain(e, domain) {
      if (e) e.preventDefault();
      $("[data-toggle='tooltip']").tooltip("hide");
      this.$router.push({
        query: {
          domain: domain.DomainId
        }
      });
      this.$refs.scrollPoint.scrollIntoView({
        // behavior: "smooth",
        block: "nearest"
      });
    },
    clearDomain(e) {
      if (e) e.preventDefault();
      this.$router.push({
        query: {}
      });
    },
    showVideoModal(e) {
      e.preventDefault();
      this.$store.dispatch("openVideoModal", true);
    }
  }
};